import { StringHelper } from "@/common/helpers/string";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { useDisplayProps } from "@/common/hooks/useDisplayProps";
import { CustomerDtoAll } from "@/common/mapping/mappers/customer";
import { ApiEnumName, enumService } from "@/common/services/enum";
import { apiClient } from "@/core/api/ApiClient";
import { CustomerDto, CustomerReferenceDto } from "@/core/api/generated/v1";

import AppIcon from "../../Icons/AppIcon";
import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";

const defaultDisplayProps = { placeholder: true };
type DisplayProps = typeof defaultDisplayProps;

export const getCustomerInlineTitle = (data: Nil<CustomerDtoAll>, displayProps?: DisplayProps) =>
  data
    ? StringHelper.join(
        [
          data.name || data.contact?.personName?.name,
          enumService.getEnumValueName(ApiEnumName.CustomerType, data.type),
        ],
        ", ",
        { skipEmpty: true },
      )
    : undefined;

export const getCustomerInlineTitleShort = (data: Nil<CustomerDtoAll>) =>
  data
    ? StringHelper.join(
        [
          data.name || data.contact?.personName?.name,
          enumService.getEnumValueName(ApiEnumName.CustomerType, data.type),
        ],
        ", ",
        { skipEmpty: true },
      )
    : undefined;

export interface CustomerInlineProps extends BaseEntityInlineInheritableProps {
  entity: CustomerDto | CustomerReferenceDto | null | undefined;
  entityId?: string | null;
  displayProps?: Partial<DisplayProps>;
}

export default function CustomerInline({
  entity,
  entityId,
  displayProps,
  ...otherProps
}: CustomerInlineProps) {
  const displayPropsComputed = useDisplayProps([defaultDisplayProps, displayProps]);

  const request = useApiRequest(
    apiClient.customersApi.apiV1CustomersCustomerIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      customerId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      icon={<AppIcon of='customer' inText />}
      content={getCustomerInlineTitle(entity, displayPropsComputed) || "Customer"}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Customer "}
    />
  );
}
